/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum SavedViewModule {
    finops_dashboard = 'finops_dashboard',
    billing_inventory = 'billing_inventory',
    next_gen_reports = 'next_gen_reports',
    cost_anomaly = 'cost_anomaly'
}
